const { isArray, isEmpty, isObject, usableValue } = require('../utils')
const rules = require('./rules')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} country
 * @param {object|undefined} state
 * @param {string|undefined} group
 * @param {string|undefined} field
 * @param {*|undefined} value
 * @param {object|undefined} validation
 * @param {array|undefined} dynamicValidation
 * @param {object|undefined} formAlternatives
 * @returns {boolean}
 */
function validateField ({ country, state, group, field, value, validation, dynamicValidation, formAlternatives = null } = {}) {
  if (
    (!isObject(validation) && !isArray(dynamicValidation)) ||
    (isEmpty(validation) && isEmpty(dynamicValidation))
  ) {
    return true
  }

  // Special check if required is set to false and no value is present
  if (
    validation?.required === false &&
    !usableValue(value)
  ) {
    return true
  }

  if (!usableValue(value)) return false

  let valid = false
  const validations = { ...validation }
  const dynamicRules = dynamicValidation || null

  // Check for dynamic validation rules and add them to the rules object before validating
  if (dynamicRules && !isEmpty(dynamicRules)) {
    for (const key in dynamicRules) {
      const item = dynamicRules[key]
      let targetGroup = item?.group
      const targetField = item?.field
      const rule = item?.rule

      // If hasCoApplicant is false we continue the loop as to not make a faulty validation on a "hidden" input(ssn for coApplicant).
      if (item?.checkAgainstOtherApplicant && state?.global?.hasCoApplicant?.value === false) {
        continue
      }

      // If the target group is applicant we change to the group from the parent in case it is a coApplicant field
      // This is needed since we only define the main applicant and copy the object to the co applicant
      if (targetGroup === 'applicant' && group) {
        targetGroup = group
      }

      // If the flag 'checkAgainstOtherApplicant' is true we switch the group to get the value for the other applicant
      if (item?.checkAgainstOtherApplicant) {
        targetGroup = targetGroup === 'applicant'
          ? 'coApplicant'
          : 'applicant'
      }

      // If the group, field and rule is set we save it to the rules object with the value of the target
      if (targetGroup && targetField && rule) {
        validations[rule] = state?.[targetGroup]?.[targetField]?.value
      }
    }
  }

  for (const rule of Object.keys(validations)) {
    const validationValue = validations[rule]

    if (
      rule &&
      rules[rule] &&
      usableValue(validationValue)
    ) {
      valid = rules[rule]({ country, state, field, value, validationValue, formAlternatives })
      if (!valid) break
    }
  }

  return valid
}

module.exports = { validateField }
